import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useParams } from 'react-router-dom';

const ComingSoon = () => {
  const { t } = useLanguage();
  const { category } = useParams();

  const categoryTitle = t(`work.categories.${category}.title`);

  return (
    <section className="min-h-screen py-24 md:py-32 px-6 bg-white flex items-center">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-light text-[#2C2C2C] lowercase mb-12">
          {categoryTitle}
        </h1>
        
        <p className="text-2xl md:text-3xl font-light text-[#5A5A5A] leading-relaxed mb-8">
          {t('work.comingSoon.text')}
        </p>

        <div className="text-xl font-light text-[#2C2C2C]">
          <span className="mr-2">{t('work.comingSoon.cta')}</span>
          <a 
            href="mailto:element@mustakova.com"
            className="text-[#2C1810] border-b border-[#2C1810] hover:opacity-70 transition-opacity duration-300"
          >
            {t('work.comingSoon.link')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
